import { colors } from 'styles/colors';

export const InfoIconGray = (): JSX.Element => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z" fill={colors.icon['soft-400']} />
    <path d="M9.375 4.625C9.87784 4.625 10.2841 5.06698 10.2841 5.61405C10.2841 6.16112 9.87784 6.6031 9.375 6.6031C8.87216 6.6031 8.46591 6.16112 8.46591 5.61405C8.46591 5.06698 8.87216 4.625 9.375 4.625ZM10.625 13.375H8.125V13.035H8.75V8.08977H8.125V7.71887H10V13.035H10.625V13.375Z" fill="white" />
  </svg>
);
